import React from 'react';
import { css } from 'linaria';
import classnames from 'classnames';
const modalBodyStyles = "mweydr9";
export const ModalBody = ({
  children,
  className
}) => <div className={classnames(modalBodyStyles, className)}>{children}</div>;
export default ModalBody;

require("../../../.linaria-cache/src/components/modal/modal-body.linaria.module.css");